(function () {
  function predictiveUrl() {
    if (window.themeHDN && themeHDN.routes && themeHDN.routes.predictive_search_url) {
      return themeHDN.routes.predictive_search_url;
    }
    if (window.routes && routes.predictive_search_url) return routes.predictive_search_url;
    if (window.Shopify && Shopify.routes && Shopify.routes.root != null) {
      return Shopify.routes.root + 'search/suggest';
    }
    return '/search/suggest';
  }

  function initStazeSearchPopup() {
    var popup = document.getElementById('searchPopup');
    if (!popup) return;

    var overlay = document.querySelector('.searchPopupOverly');
    var input = popup.querySelector('.search__input');
    var resultsList = popup.querySelector('.search-results');
    var closeBtns = popup.querySelectorAll('.closeSearch');
    var abortController = null;
    var debounceTimer = null;

    function openPopup(e) {
      if (e) e.preventDefault();
      document.body.classList.add('showOverly');
      if (overlay) overlay.hidden = false;
      popup.classList.add('active');
      popup.setAttribute('aria-hidden', 'false');
      setTimeout(function () {
        if (input) {
          input.focus();
          var len = input.value.length;
          try { input.setSelectionRange(len, len); } catch (err) {}
        }
      }, 50);
    }

    function closePopup() {
      document.body.classList.remove('showOverly');
      if (overlay) overlay.hidden = true;
      popup.classList.remove('active');
      popup.setAttribute('aria-hidden', 'true');
    }

    function runPredictive() {
      if (!input || !resultsList) return;
      var term = (input.value || '').trim();

      if (term.length <= 2) {
        resultsList.innerHTML = '';
        resultsList.style.display = 'none';
        return;
      }

      if (abortController) abortController.abort();
      abortController = new AbortController();

      var url =
        predictiveUrl() +
        '?q=' +
        encodeURIComponent(term) +
        '&resources[type]=product&resources[limit]=8&section_id=predictive-search';

      fetch(url, { signal: abortController.signal })
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var section = doc.querySelector('#shopify-section-predictive-search');
          var markup = section ? section.innerHTML : '';
          resultsList.innerHTML = markup;
          resultsList.style.display = markup.trim() ? 'flex' : 'none';
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          resultsList.innerHTML = '';
          resultsList.style.display = 'none';
        });
    }

    // Header search icon(s)
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest(
        '.searchIco, .hdt-site-nav_search a, [data-open-search-popup]'
      );
      if (!trigger) return;
      // Bottom toolbar Search tab should still go to /search
      if (trigger.closest('.hdt-toolbart-search, .hdt-toolbar-item')) return;
      openPopup(e);
    });

    // Desktop header search input → open popup instead of inline HDT predictive
    document.addEventListener(
      'focusin',
      function (e) {
        var desktopInput = e.target.closest(
          '.hdt-header-col-search .hdt-search_input, .hdt-header-col-search input[name="q"]'
        );
        if (!desktopInput) return;
        if (popup.contains(desktopInput)) return;
        openPopup(e);
      },
      true
    );

    document.addEventListener(
      'click',
      function (e) {
        var desktopInput = e.target.closest(
          '.hdt-header-col-search .hdt-search_input, .hdt-header-col-search input[name="q"], .hdt-header-col-search .hdt-search_form'
        );
        if (!desktopInput) return;
        if (popup.contains(desktopInput)) return;
        openPopup(e);
      },
      true
    );

    // Desktop header form should open popup, not navigate
    document.querySelectorAll('.hdt-header-col-search form[action*="search"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        openPopup(e);
      });
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closePopup();
      });
    });

    if (overlay) {
      overlay.addEventListener('click', closePopup);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('active')) closePopup();
    });

    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(runPredictive, 250);
      });
      input.addEventListener('keyup', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(runPredictive, 250);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStazeSearchPopup);
  } else {
    initStazeSearchPopup();
  }
})();
